import * as React from "react";
import TagManager from "react-gtm-module";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { AppProviders } from "../providers/AppProviders";
import "../styles/globals.css";
import "../commands/commands"; // Import commands to register them

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  if (process.env.APP_ENV === "production") {
    TagManager.initialize({
      gtmId: "G-QXZ8PGJTGT",
    });
  }

  root?.render(
    <AppProviders>
      <App />
    </AppProviders>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(
      <AppProviders>
        <NextApp />
      </AppProviders>
    );
  });
}
